import { useMemo } from 'react';
import type { TGameMap } from '@opm/pages/CompetitorAdComparison/hooks/useGameMap';

/** useGameMeta 最小输入约束（ITrendItem / ITrendDetail 均满足） */
export interface IGameIdentifiable {
  game_id?: string;
  game_name?: string;
  game_cover?: string;
}

export interface IGameMetaResult {
  /** 游戏名称（优先 gameMap → record 自带 → game_id 占位） */
  gameName: string;
  /** 游戏封面 URL */
  gameLogo: string;
  /** 原始 gameMap 条目（如需透传其他字段） */
  gameMeta?: TGameMap[string];
}

/**
 * 从 record + gameMap 中提取游戏元信息的公共 hook
 *
 * 取值优先级：gameMap[game_id] → record 自带字段（旧兼容） → game_id 占位
 * 4 处消费方统一逻辑：TrendInfoRows / TrendTopicCell / TrendCard / TrendInfo
 */
export function useGameMeta(
  record: IGameIdentifiable | null,
  gameMap?: TGameMap,
): IGameMetaResult {
  return useMemo(() => {
    if (!record) return { gameName: '-', gameLogo: '' };

    const gameMeta = record.game_id ? gameMap?.[record.game_id] : undefined;
    return {
      gameName: gameMeta?.game_name || record.game_name || record.game_id || '-',
      gameLogo: gameMeta?.cover || record.game_cover || '',
      gameMeta,
    };
  }, [record, gameMap]);
}
